// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsClsInboundAddress } from './tCApiGatewayControllersModelsClsInboundAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundPrescriber {
    'firstName'?: string | null;
    'lastName'?: string | null;
    'officePhone'?: string | null;
    'npi'?: string | null;
    'status'?: string | null;
    'accountType'?: string | null;
    'specialistType'?: string | null;
    'tC_OfficeContactName__c'?: string | null;
    'fax'?: string | null;
    'prescriberAddress'?: Array<TCApiGatewayControllersModelsClsInboundAddress> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundPrescriber>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "officePhone",
            "baseName": "officePhone",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "status",
            "baseName": "status",
            "type":     "string"
        },
        {
            "name":     "accountType",
            "baseName": "accountType",
            "type":     "string"
        },
        {
            "name":     "specialistType",
            "baseName": "specialistType",
            "type":     "string"
        },
        {
            "name":     "tC_OfficeContactName__c",
            "baseName": "tC_OfficeContactName__c",
            "type":     "string"
        },
        {
            "name":     "fax",
            "baseName": "fax",
            "type":     "string"
        },
        {
            "name":     "prescriberAddress",
            "baseName": "prescriberAddress",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundAddress>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundPrescriber.attributeTypeMap;
    }
}
